// src/features/Management/page/Menus

import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { menuType } from '../../types/managementTypes';
import { useTranslation } from 'react-i18next';



const SubMenuPage = () => {

    const { t } = useTranslation();

  // Define columns for the Menu table
  const subMenuColumns: ColumnsType<menuType> = [
    { title: "Name", dataIndex: "name", key: "name", sorter: true },
    { title: "Arabic Name", dataIndex: "nameAr", key: "nameAr" },
    // {
    //   title: "Sub Menus",
    //   dataIndex: "subMenus",
    //   key: "subMenus",
    //   render: (subMenus: menuType[]) => (
    //     <Space size={[0, 8]} wrap>
    //       {subMenus?.map((menu) => (
    //         <Tag color="blue" key={menu.id}>
    //           {menu.name}
    //         </Tag>
    //       ))}
    //     </Space>
    //   ),
    // },
    { title: "Icon Name", dataIndex: "icon", key: "icon" }, 
    { title: "Display Order", dataIndex: "displayOrder", key: "displayOrder" }
  ];

  return (
    <div>
      
          <DynamicTable<menuType> // Ensure generic type matches the data
              dataApiUrl={API_ENDPOINTS.MANAGEMENT.GET_SUB_MENUS} // Your API endpoint for fetching menus
              baseQueryKey={QUERY_KEYS.MANAGEMENT.SUBMENUS} // Unique query key for menus
              columns={subMenuColumns}
        tableTitle={t("Sub Menu(s)")}
        deleteBaseUrl={API_ENDPOINTS.MANAGEMENT.DELETE_SUB_MENU}
        showActions={true} // Set to true if you want Edit/Delete actions
        // Pass the fields you want the search bar to filter
        filterConfigs={[
          { field: "name", placeholder: "Search by Name" },
          {
                        field: 'menuId',
                        type: 'select',
                        placeholder: "Select menu",
                        showSearch: true,
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["menu"] },
                            transformData: (apiResponse: unknown) => {
                                const response = apiResponse as { menu: { Name: string; Id: number }[] };
                                return response.menu.map((item) => ({ label: item.Name, value: item.Id }))
                            }
                        },
                    },
         
        ]}
      />
    </div>
  );
};

export default SubMenuPage;